"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tracking = void 0;
var _cookie = require("../../utils/cookie");
var _analyticsState = require("./analytics-state");
var _cohort = require("./cohort");
var _gasv = require("./gasv3");
var _gtmIntegration = require("./gtm-integration");
var _guid = require("../../utils/guid");
var _helpers = require("./helpers");
var _identity = require("./identity");
var _types = require("../community-analytics/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tracking = exports.Tracking = /*#__PURE__*/function () {
  function Tracking() {
    _classCallCheck(this, Tracking);
  }
  return _createClass(Tracking, null, [{
    key: "_getEventDomain",
    value: function _getEventDomain() {
      return location && location.href ? new URL(location.href).hostname : '';
    }
  }, {
    key: "_browserSupportsPromises",
    value: function _browserSupportsPromises() {
      return typeof Promise === 'function';
    }
  }, {
    key: "_userOptedOutOfTrackingCookies",
    value: function _userOptedOutOfTrackingCookies() {
      return window.OnetrustActiveGroups && !/,4,/.exec(window.OnetrustActiveGroups);
    }
  }, {
    key: "_shouldUsePromise",
    value: function _shouldUsePromise() {
      // return false for now, since Marketo is not supported with new community core apps;
      // the promise logic is used to retrieve the Marketo ID cookie
      // see atl-analytics atl-events.js for more details about marketo domains
      //return Tracking._browserSupportsPromises() && !Tracking._userOptedOutOfTrackingCookies();
      return false;
    }

    /**
     * Sends a GASv3 event of any event type
     * @method trackEvent
     * @param {string} event the name of the event, sets 'trackEventName' on data (historically used by segment)
     * @param {object} data the properties to be sent with the event
     * @param {string} type the type of event to send (UI, SCREEN, TRACK, OPERATIONAL)
     */
  }, {
    key: "trackEvent",
    value: function trackEvent(event, data) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _types.eventType.UI;
      if (Tracking._shouldUsePromise()) {
        void Tracking.enrichEventDataPromise(data).then(function (enrichedData) {
          return Tracking._trackEvent(event, enrichedData, type);
        })["catch"](function (e) {
          console.warn('enrich Event + tracking._trackEvent invocation failed', e);
        });
      } else {
        try {
          data = Tracking.enrichEventData(data);
          Tracking._trackEvent(event, data, type);
        } catch (e) {
          console.warn('enrich Event + tracking._trackEvent invocation failed', e);
        }
      }
    }

    /**
     * NOTE: The original marketing atl-analytics wrapper only supports UI and Screen (for viewed page) events;
     * This is a community enhancement, supporting Track and Operational events
     */
  }, {
    key: "_trackEvent",
    value: function _trackEvent(event, enrichedData, type) {
      switch (type) {
        case _types.eventType.SCREEN:
          _gasv.GASv3.sendScreenEvent(event, enrichedData);
          break;
        case _types.eventType.TRACK:
          _gasv.GASv3.sendTrackEvent(event, enrichedData);
          break;
        case _types.eventType.OPERATIONAL:
          _gasv.GASv3.sendOperationalEvent(event, enrichedData);
          break;
        case _types.eventType.UI:
        default:
          _gasv.GASv3.sendUIEvent(event, enrichedData);
          break;
      }
    }

    /**
     * send a page/screen event
     * @function pageView
     * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
     * @param {object} pageViewOptions - optional, dictionary options to enable or disable specific integrations for the call (see: https://segment.com/docs/libraries/analytics.js/#page)
     * */
  }, {
    key: "pageView",
    value: function pageView(pageViewProperties) {
      if (Tracking._shouldUsePromise()) {
        void Tracking.enrichEventDataPromise(pageViewProperties).then(function (enrichedPageViewProperties) {
          Tracking._pageView(enrichedPageViewProperties);
        })["catch"](function (e) {
          console.warn('enrich Event + tracking._pageView invocation failed', e);
        });
      } else {
        try {
          pageViewProperties = Tracking.enrichEventData(pageViewProperties);
          Tracking._pageView(pageViewProperties);
        } catch (e) {
          console.warn('enrich Event + tracking._pageView invocation failed', e);
        }
      }
    }
  }, {
    key: "_pageView",
    value: function _pageView(enrichedPageViewProperties) {
      enrichedPageViewProperties.wrapperName = 'atl-global';
      enrichedPageViewProperties.destinationFlag = 'gasv3';
      if (window.cmsPageVariant) {
        enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
      }
      _gtmIntegration.Gtm.page(null, null, enrichedPageViewProperties);
      _gasv.GASv3.sendScreenEvent(null, enrichedPageViewProperties);
    }

    /**
     * Gets the pageViewId. Creates one if it doesn't exist
     * @function getPageViewId()
     */
  }, {
    key: "getPageViewId",
    value: function getPageViewId() {
      if (!Tracking.pageViewId) {
        Tracking.pageViewId = _guid.Guid.guid();
      }
      return Tracking.pageViewId;
    }

    /**
     * adds common data attributes to all track/UI and page/screen events
     * @function enrichEventData
     * @param {object} data the data to enrich
     */
  }, {
    key: "enrichEventDataPromise",
    value: function enrichEventDataPromise(data) {
      // If the data contains a href, then we have clicked a link and are navigating away
      // to a different page, so we don't have time to wait for the retry logic.
      var enableRetryForMarketoId = !(data !== null && data !== void 0 && data.href) && !(data !== null && data !== void 0 && data.form);
      return new Promise(function (resolve) {
        void _identity.Identity.getMarketoIdPromise(enableRetryForMarketoId).then(function (marketoId) {
          resolve(Tracking._enrichEventData(data, marketoId));
        });
      });
    }

    /**
     * adds common data attributes to all track/UI and page/screen events
     * @function enrichEventData
     * @param {object} data the data to enrich
     */
  }, {
    key: "enrichEventData",
    value: function enrichEventData(data) {
      return Tracking._enrichEventData(data, _identity.Identity.getMarketoId());
    }
  }, {
    key: "_enrichEventData",
    value: function _enrichEventData(inputData, marketoId) {
      var data = {};
      if (_typeof(inputData) !== 'object' || inputData === null) {
        var dataValue = inputData;
        if (typeof dataValue !== 'undefined') {
          data['data'] = dataValue;
        }
      } else {
        data = inputData;
      }

      // if not already done, read the request Id cookie set by bxp-gateway
      if (!Tracking.bxpGatewayRequestId) {
        Tracking.bxpGatewayRequestId = _cookie.Cookie.readCookie('bxp_gateway_request_id');
      }
      // Only set the property if the cookie was there and readCookie didn't return null
      if (Tracking.bxpGatewayRequestId) {
        data['bxpGatewayRequestId'] = Tracking.bxpGatewayRequestId;
      }
      data['pageViewId'] = Tracking.getPageViewId();

      // add identity data, if not present
      data['atlEventId'] = _guid.Guid.guid();
      data['atlJSVersion'] = _analyticsState.AnalyticsState.version || '1.0.0';
      data['browserLanguages'] = navigator.languages;

      // add category, if not present
      data['category'] = data['category'] || (document.title !== 'undefined' ? document.title.trim().replace(/\W+/g, '_') : '');
      // add the cohort to the object
      data[_cohort.ATL_COHORT] = _cohort.Cohort.readWriteAtlCohort();
      var utms = _analyticsState.AnalyticsState.utms;
      if (utms) {
        data['campaign'] = {
          name: utms['utm_campaign'],
          medium: utms['utm_medium'],
          source: utms['utm_source'],
          content: utms['utm_content'],
          term: utms['utm_term']
        };
      }
      data['clientSessionId'] = Tracking.readWriteSessionCookie();
      if (Tracking.xid) {
        data['atlXid'] = Tracking.xid;
      }
      data['marketoId'] = marketoId ? marketoId : '';
      return data;
    }

    /**
     * @function buildTrackEventProperties
     * @param {HTMLElement} el target element
     * @param {object} dataset takes data set from event.target.dataset
     * @param {string} label
     * @param {string} href
     * @returns {object} trackEventProperties
     */
  }, {
    key: "buildTrackEventProperties",
    value: function buildTrackEventProperties(el, dataset, label, href) {
      if (!dataset) {
        return;
      }
      var trackEventProperties = {
        label: label,
        href: href
      };
      if (el && el.nodeName === 'BUTTON') {
        var form = el.getAttribute('form');
        if (form) {
          trackEventProperties.form = form;
        }
      }
      var expectedProperties = ['actionSubjectId', 'eventContainer', 'eventColumn', 'eventComponent', 'uuid', 'event', 'inputValue', 'parentLabel', 'label', 'labelEnglish', 'productKey', 'productVersion', 'productEdition', 'productPlatform', 'schemaVersion', 'name'];
      var isExpectedProperty = function isExpectedProperty(value) {
        return expectedProperties.includes(value);
      };
      var dataSetEntries = [];
      for (var dataProperty in dataset) {
        // eslint-disable-next-line no-prototype-builtins
        if (dataProperty !== 'track-event' && dataset.hasOwnProperty(dataProperty)) {
          var dataPropertyValue = dataset[dataProperty];
          if (dataPropertyValue) {
            if (isExpectedProperty(dataProperty)) {
              trackEventProperties[dataProperty] = dataPropertyValue;
            } else {
              var dataEntry = {};
              dataEntry[dataProperty] = dataPropertyValue;
              dataSetEntries.push(dataEntry);
            }
          }
        }
      }
      trackEventProperties.dataSet = dataSetEntries;
      return trackEventProperties;
    }

    /**
     * callback for auto track click events
     * @function _autoTrackClickEvent
     * @ignore
     */
    // eslint-disable-next-line complexity
  }, {
    key: "_autoTrackClickEvent",
    value: function _autoTrackClickEvent(event) {
      try {
        var currentTargetElem = event.currentTarget;
        var targetElem = event.target;
        var rawText = targetElem.textContent;
        var isInput = function isInput(elem) {
          return elem.tagName === 'INPUT';
        };
        var isAnchor = function isAnchor(elem) {
          return elem.hasAttribute('href');
        };
        var isSelect = function isSelect(elem) {
          return elem.tagName === 'SELECT';
        };

        // handle form buttons differently
        if (isInput(targetElem)) {
          // targetElem.value of an input text field is considered UGC and should not be tracked
          rawText = targetElem.type === 'text' ? '[REDACTED]' : targetElem.value !== '' ? targetElem.value : targetElem.textContent;
        } else if (isSelect(targetElem)) {
          targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
          rawText = targetElem.getAttribute('data-label') || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
        } else if (rawText === '') {
          var _targetElem$parentNod;
          rawText = ((_targetElem$parentNod = targetElem.parentNode) === null || _targetElem$parentNod === void 0 ? void 0 : _targetElem$parentNod.textContent) || targetElem.title || targetElem.ariaLabel || targetElem.className;
        }
        var href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : '';
        var trackEventName = targetElem.getAttribute('data-track-event') || currentTargetElem.getAttribute('data-track-event') || 'Clicked-Auto-CTA';
        var eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, '-') : '';
        var trackEventProperties = Tracking.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
        //@ts-ignore
        Tracking.trackEvent(trackEventName, trackEventProperties);
      } catch (err) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking click event');
      }
    }

    /**
     * queries the document for all selects and adds a change handler to them for tracking
     * @function autoTrackSelects
     */
  }, {
    key: "autoTrackSelects",
    value: function autoTrackSelects() {
      try {
        var selects = Array.from(document.querySelectorAll('select'));
        for (var _i = 0, _selects = selects; _i < _selects.length; _i++) {
          var select = _selects[_i];
          if (!Tracking.isAutoTrackingDisabled(select)) {
            select.removeEventListener('change', Tracking._autoTrackClickEvent);
            select.addEventListener('change', Tracking._autoTrackClickEvent);
          }
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking select event');
      }
    }

    /**
     * queries the document for all submit buttons and adds a click handler to them for tracking
     * @function autoTrackButtons
     * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
     */
  }, {
    key: "autoTrackButtons",
    value: function autoTrackButtons(trackAll) {
      try {
        var selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
        var btns = Array.from(document.querySelectorAll(selector));
        for (var _i2 = 0, _btns = btns; _i2 < _btns.length; _i2++) {
          var btn = _btns[_i2];
          if (!Tracking.isAutoTrackingDisabled(btn)) {
            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
            btn.removeEventListener('click', Tracking._autoTrackClickEvent);
            // add an event listener
            btn.addEventListener('click', Tracking._autoTrackClickEvent);
          }
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking button event');
      }
    }

    /**
     * queries the document for all links with a class of 'button', 'btn', 'cta' and 'external-link' and adds click handler for tracking
     * @function autoTrackLinks
     * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
     */
  }, {
    key: "autoTrackLinks",
    value: function autoTrackLinks(trackAll) {
      try {
        var links = [],
          selector = trackAll ? 'a, .external-link' : "a[class*='button'], a[class*='btn'], .external-link",
          btnyLinks = Array.from(document.querySelectorAll(selector));
        for (var _i3 = 0, _btnyLinks = btnyLinks; _i3 < _btnyLinks.length; _i3++) {
          var el = _btnyLinks[_i3];
          var htmlEl = el;
          if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes('cta') || el.className.includes('external-link')) {
            links.push(el);
          }
        }
        for (var _i4 = 0, _links = links; _i4 < _links.length; _i4++) {
          var link = _links[_i4];
          if (!Tracking.isAutoTrackingDisabled(link)) {
            link.removeEventListener('click', Tracking._autoTrackClickEvent);
            link.addEventListener('click', Tracking._autoTrackClickEvent);
          }
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking link event');
      }
    }

    /**
     * callback for auto track video events
     * @function _autoTrackVideoEvent
     * @ignore
     */
  }, {
    key: "_autoTrackVideoEvent",
    value: function _autoTrackVideoEvent(element, eventName) {
      try {
        var _element$parentElemen;
        var className = typeof element.className !== 'undefined' ? element.className : (_element$parentElemen = element.parentElement) === null || _element$parentElemen === void 0 ? void 0 : _element$parentElemen.className,
          eventLabel = typeof element.textContent !== 'undefined' ? element.textContent : '',
          eventCategory = typeof document.title !== 'undefined' ? document.title.replace(/\W+/g, '_').trim() : '';
        Tracking.trackEvent(eventName, {
          className: className,
          category: eventCategory,
          label: eventLabel,
          _sio: _cookie.Cookie.readCookie('_sio') || '',
          _atl_path: _cookie.Cookie.readCookie('__atl_path') || ''
        });
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking video event');
      }
    }

    /**
     * queries the document for all divs with video open and close links and adds a click handler for tracking
     * @function autoTrackVideos
     */
  }, {
    key: "autoTrackVideos",
    value: function autoTrackVideos() {
      try {
        var videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
        var videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
        var trackVideoOpenEvent = function trackVideoOpenEvent(ev) {
          var currentTargetElem = ev.currentTarget;
          Tracking._autoTrackVideoEvent(currentTargetElem, 'Opened Video');
        };
        var trackVideoCloseEvent = function trackVideoCloseEvent(ev) {
          var currentTargetElem = ev.currentTarget;
          Tracking._autoTrackVideoEvent(currentTargetElem, 'Closed Video');
        };
        for (var _i5 = 0, _videoOpenLinks = videoOpenLinks; _i5 < _videoOpenLinks.length; _i5++) {
          var videoOpenLink = _videoOpenLinks[_i5];
          videoOpenLink.removeEventListener('click', trackVideoOpenEvent);
          videoOpenLink.addEventListener('click', trackVideoOpenEvent);
        }
        for (var _i6 = 0, _videoCloseLinks = videoCloseLinks; _i6 < _videoCloseLinks.length; _i6++) {
          var videoCloseLink = _videoCloseLinks[_i6];
          videoCloseLink.removeEventListener('click', trackVideoCloseEvent);
          videoCloseLink.addEventListener('click', trackVideoCloseEvent);
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking video event');
      }
    }

    /**
     * queries the document for all role='tab' and adds a click handler to them for tracking
     * @function autoTrackTabs
     */
  }, {
    key: "autoTrackTabs",
    value: function autoTrackTabs() {
      try {
        var selector = "[role='tab']";
        var tabs = Array.from(document.querySelectorAll(selector));
        for (var _i7 = 0, _tabs = tabs; _i7 < _tabs.length; _i7++) {
          var tab = _tabs[_i7];
          if (!Tracking.isAutoTrackingDisabled(tab)) {
            // remove existing event listener (to prevent redundant listeners from useEffect hooks)
            tab.removeEventListener('select', Tracking._autoTrackClickEvent);
            // add an event listener
            tab.addEventListener('select', Tracking._autoTrackClickEvent);
          }
        }
      } catch (e) {
        _helpers.Helpers.sendWrapperLoadError('Error auto-tracking tab event');
      }
    }

    /**
     * check to see if the element in question contains class 'doNotAutoTrack'
     * @function isAutoTrackingDisabled
     * @param element
     */
  }, {
    key: "isAutoTrackingDisabled",
    value: function isAutoTrackingDisabled(element) {
      return element.classList.contains('doNotAutoTrack');
    }

    /**
     * return an existing session cookie
     * @function readWriteSessionCookie
     * @returns {string}
     */
  }, {
    key: "readWriteSessionCookie",
    value: function readWriteSessionCookie() {
      var cookie = _cookie.Cookie.readCookie('atl_session');
      var name = 'atl_session';
      var value = cookie || _guid.Guid.guid();
      var seconds = 30 * 60;
      if (_cookie.Cookie.writeCookieInSeconds) {
        _cookie.Cookie.writeCookieInSeconds(name, value, seconds);
      }
      return value;
    }
  }]);
}();